/*
 * Copyright (c) 2026. Orion Analytics. All Rights Reserved
 */

import {
    BarChart3,
    Landmark,
    Briefcase,
    Shield,
    Brain,
    BookOpen
} from "lucide-react";

export default function ProductSection() {

    const products = [

        ["Stocks","/stock",BarChart3],
        ["Mutual Funds","/mf",Landmark],
        ["Portfolio","/portfolio",Briefcase],
        ["Risk Analytics","/ra",Shield],
        ["AI Research","/research",Brain],
        ["Academy","/academy",BookOpen]
    ];

    return (

        <section className="mb-20">

            <h2 className="
                text-3xl
                font-bold
                text-slate-900
                mb-8
            ">
                Explore Orion Analytics
            </h2>

            <div className="
                grid
                md:grid-cols-2
                lg:grid-cols-3
                gap-6
            ">

                {products.map(([name,url,Icon]) => (

                    <a
                        key={name}
                        href={url}
                        className="
                            bg-white
                            rounded-3xl
                            border
                            border-slate-200
                            p-8
                            hover:shadow-xl
                            transition-all
                        "
                    >

                        <Icon
                            className="
                                text-emerald-500
                                mb-5
                            "
                            size={32}
                        />

                        <h3 className="
                            text-xl
                            font-bold
                            text-slate-900
                        ">
                            {name}
                        </h3>

                    </a>
                ))}

            </div>

        </section>
    );
}